import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 7 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 9\" id=\"chevron\">\n  <g stroke-width=\"1\" stroke-linecap=\"square\" fill=\"none\">\n    <path d=\"M2.1813382,4.5 L5.6624748,7.9860075 L6,8.324005 L5.3249496,9 L4.9874244,8.6620025 L1.5062878,5.175995 L0.8312374,4.5 L1.1687626,4.1620025 L4.9874244,0.33799749 L5.3249496,0 L6,0.67599497 L5.6624748,1.01399246 L2.1813382,4.5 Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol